import Keycloak from 'keycloak-js';
import config from './config';

const keycloak = new Keycloak({
  url:
    config[process.env.REACT_APP_ENVIRONMENT]?.keycloakUrl ||
    config.default.keycloakUrl,
  realm:
    config[process.env.REACT_APP_ENVIRONMENT]?.realm || config.default.realm,
  clientId:
    config[process.env.REACT_APP_ENVIRONMENT]?.clientId ||
    config.default.clientId,
});

export default keycloak;
